import { scopeSizeResponseSchema } from '@tempo-io/reporting-store-dto';
import { REPORTING_STORE_API_BASE } from '@/common/api/reporting-store/constants';
import { tempoApi } from '@/common/api/tempoApi';
import type { ParsedInsightsFilters } from '@/common/api/types/dashboard/filters';
import { buildInsightsApiFilter } from '@/features/insights-dashboard/utils/buildInsightsApiFilter';

const getScopeSize = async ({
  filters,
  scopeItemId,
  loopId,
}: {
  filters?: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
}) => {
  const filterString = buildInsightsApiFilter(filters ?? {}, scopeItemId, loopId);
  const response = await tempoApi()
    .get(`${REPORTING_STORE_API_BASE}/scope-size`, {
      searchParams: {
        ...(filterString && { filter: filterString }),
      },
    })
    .json();
  return scopeSizeResponseSchema.parse(response);
};

export const ScopeSizeApi = { getScopeSize };
